import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  ArrowRight,
  Wallet,
  PiggyBank,
  BarChart3,
  CreditCard,
  Target,
  DollarSign,
} from "lucide-react";

const floatingIcons = [
  { Icon: Wallet, position: "top-16 left-[10%]", delay: "0s", size: "h-6 w-6" },
  { Icon: PiggyBank, position: "top-32 right-[12%]", delay: "1.5s", size: "h-7 w-7" },
  { Icon: BarChart3, position: "bottom-32 left-[8%]", delay: "0.8s", size: "h-5 w-5" },
  { Icon: CreditCard, position: "top-20 right-[25%]", delay: "2.2s", size: "h-5 w-5" },
  { Icon: Target, position: "bottom-24 right-[10%]", delay: "1s", size: "h-6 w-6" },
  { Icon: DollarSign, position: "bottom-40 left-[22%]", delay: "1.8s", size: "h-5 w-5" },
];

export function HeroSection() {
  const navigate = useNavigate();

  const handleScrollToPricing = () => {
    const pricingSection = document.getElementById("pricing");
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-gradient-to-br from-background via-background to-primary/10 pt-16">
      {/* Gradient orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-primary/10 rounded-full blur-3xl pointer-events-none" />

      {/* Floating icons */}
      {floatingIcons.map(({ Icon, position, delay, size }, index) => (
        <div
          key={index}
          className={`absolute ${position} hidden lg:flex items-center justify-center w-12 h-12 rounded-xl bg-card/60 border border-border/50 backdrop-blur-sm shadow-sm animate-float`}
          style={{ animationDelay: delay }}
        >
          <Icon className={`${size} text-primary/60`} />
        </div>
      ))}

      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-foreground leading-tight">
            Suas finan&ccedil;as no controle.{" "}
            <span className="bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
              Sua vida em equil&iacute;brio.
            </span>
          </h1>

          {/* Sub-headline */}
          <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Organize contas, planeje o futuro e tome decis&otilde;es com
            intelig&ecirc;ncia &mdash; tudo em um s&oacute; lugar.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <Button
              size="lg"
              onClick={() => navigate("/auth?tab=signup")}
              className="text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
            >
              Comece Gr&aacute;tis
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={handleScrollToPricing}
              className="text-lg px-8 py-6"
            >
              Conhe&ccedil;a os Planos
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
